import { Button, Theme } from '@cian/ui-kit';
import * as React from 'react';

import * as styles from './PurchaseTermsSection.css';

interface IPurchaseTermsPromoProps {
  onMoreButtonClick(): void;
}

export const PurchaseTermsSection: React.FC<React.PropsWithChildren<IPurchaseTermsPromoProps>> = ({
  onMoreButtonClick,
  children,
}) => {
  return (
    <div className={styles['container']} data-testid="PurchaseTermsSection">
      <div>{children}</div>
      <div className={styles['more-button']}>
        <Theme theme="onOverlay">
          <Button
            fullWidth
            onClick={onMoreButtonClick}
            theme="fill_secondary"
            data-testid="PurchaseTermsSectionMoreButton"
          >
            Ещё способы покупки
          </Button>
        </Theme>
      </div>
    </div>
  );
};
